import { ObjectSchema } from '@src/__generated__/types';

export enum ModeType {
    EDIT = 'EDIT',
    NEW_CONTENT_TYPE_GROUP = 'NEW_CONTENT_TYPE_GROUP',
    NEW_CONTENT_TYPE = 'NEW_CONTENT_TYPE',
    NEW_PRODUCT_INFO = 'NEW_PRODUCT_INFO',
    EDIT_PRODUCT_INFO = 'EDIT_PRODUCT_INFO',
    EDIT_CONTENT_TYPE = 'EDIT_CONTENT_TYPE',
    EDIT_CONTENT_TYPE_GROUP = 'EDIT_CONTENT_TYPE_GROUP',
    VIEW_CONTENT_TYPES = 'VIEW_CONTENT_TYPES',
    VIEW_CONTENT_TYPE_GROUP = 'VIEW_CONTENT_TYPE_GROUP',
}

export interface ProductData {
    items: ObjectSchema[];
}
